import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

// material
import {
  Avatar,
  Badge,
  Box,
  Button,
  Grid,
  Menu,
  MenuItem,
  Stack,
  Toolbar,
  Tooltip,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'react-redux-multilingual';
import { useNavigate, useParams } from 'react-router-dom';

// import LanguageIcon from '@mui/icons-material/Language';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import BookOutlinedIcon from '@mui/icons-material/BookOutlined';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import SearchIcon from '@mui/icons-material/Search';
import StarIcon from '@mui/icons-material/Star';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// components
import DefaultAvatar from '../../assets/defaultPostImg.jpg';
import SearchBar from '../../components/SearchBar';
import {
  resetState,
  setIsNewNotification,
  setIsOpenAuthModal,
  setSocketInfoMsg,
  setUserData,
  setUserNotifications,
  setUserSubscribers,
  setUserSubscriptions
} from '../../redux/mainReducer';
import AuthModal from '../../pages/modals/AuthModal';
import './Header.css';
import ApiService from '../../helpers/apiHelper';
import Notification from '../../components/Notification';
import { Spinner } from '../../components/Spinner';
import { base } from '../../redux/thunk';

//

// ----------------------------------------------------------------------

const APPBAR_MOBILE = 70;
// const APPBAR_DESKTOP = 60;

const RootStyle = styled('header')(({ theme }) => ({
  boxShadow: 'none',
  background: '#fff',
  position: 'fixed',
  maxWidth: '1440px',
  zIndex: '999 !important',
  [theme.breakpoints.up('xs')]: {
    width: `100%`,
    padding: '5px 0px'
  },
  [theme.breakpoints.up('sm')]: {
    width: `100%`,
    padding: '5px 10px'
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('xs')]: {
    minHeight: APPBAR_MOBILE,
    padding: '10px 10px'
  }
}));
const StyledButton = styled(Button)(({ theme }) => ({
  '& .MuiButtonBase-root:hover': {
    backgroundColor: 'transparent',
    background: '#60a5df !important',
    color: 'white !important'
  },
  marginLeft: '20px',
  display: 'flex',
  flexDirection: 'column',
  transition: 'all 0.5s',
  cursor: 'pointer',
  width: '160px !important',
  minWidth: '160px',
  height: '40px',
  borderRadius: '50px !important',
  padding: '2px 24px',

  color: '#60A5DF',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '18px',
  textTransform: 'inherit',
  fontFamily: 'FixelText-Medium !important',
  border: '2px solid #60A5DF !important'
}));

// ----------------------------------------------------------------------

Navbar.propTypes = {
  onOpenSidebar: PropTypes.func
};

function Navbar(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const translate = useTranslate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElN, setAnchorElN] = useState(null);
  const scrollRefNotif = useRef(null);
  const [notifMaxCount, setNotifMaxCount] = useState(0);
  const [notifPage, setNotifPage] = useState(0);
  const [isLoading, setIsLoadiang] = useState(false);
  const [isLoadingMore, setIsLoadiangMore] = useState(false);
  const [isScrollNeeded, setIsScrollNeeded] = useState(false);
  const isOpenAuthModal = useSelector((state) => state.global.isOpenAuthModal);
  const isNewMessage = useSelector((state) => state.global.isNewMessage);
  const isNewNotification = useSelector((state) => state.global.isNewNotification);
  const userNotifications = useSelector((state) => state.global.userNotifications);
  const socketInfoMsg = useSelector((state) => state.global.socketInfoMsg);
  const params = useParams();

  const apiNotification = new ApiService('notification/notification/get-all-notification');
  const apiNotificationDelete = new ApiService('notification/notification');
  const apiNotificationDeleteAll = new ApiService('notification/notification/delete-all');

  // const apiNotification = new ApiService('/notification/get-all-notification');
  // const apiNotificationDelete = new ApiService('/notification');
  // const apiNotificationDeleteAll = new ApiService('/notification/delete-all');

  const open = Boolean(anchorEl);
  const openN = Boolean(anchorElN);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickN = (event) => {
    setIsLoadiang(true);
    setAnchorElN(event.currentTarget);
    apiNotification
      .getAll({ page: 0, size: 5 })
      .then((res) => {
        dispatch(setUserNotifications(res?.result));
        setNotifMaxCount(res?.total);
        setIsLoadiang(false);
      })
      .catch((error) => console.error(error));
  };
  const handleLoadMoreNotif = () => {
    setIsLoadiangMore(true);
    setIsScrollNeeded(true);
    apiNotification
      .getAll({ page: notifPage + 1, size: 5 })
      .then((res) => {
        dispatch(setUserNotifications([...userNotifications, ...res?.result]));
        setNotifMaxCount(res?.total);
        setNotifPage(notifPage + 1);
        setIsLoadiangMore(false);
      })
      .catch((error) => console.error(error));
  };
  const handleClickNDelete = (delType, id) => {
    setIsScrollNeeded(false);
    if (delType === 'item') {
      apiNotificationDelete
        .deleteBody([id])
        .then((res) => {
          const newUserNotifications = userNotifications.filter((el) => el.id !== id);
          dispatch(setUserNotifications([...newUserNotifications]));
          if (newUserNotifications.length === 0) {
            dispatch(setIsNewNotification(false));
          }
        })
        .catch((error) => console.error(error));
    } else {
      apiNotificationDeleteAll
        .deleteItemQuery({ userId: props?.userData?.id })
        .then((res) => {
          dispatch(setUserNotifications([]));
          dispatch(setIsNewNotification(false));
        })
        .catch((error) => console.error(error));
    }
  };

  const handleCloseN = () => {
    setAnchorElN(null);
  };
  useEffect(() => {
    if (!openN) {
      setNotifMaxCount(0);
      setNotifPage(0);
      dispatch(setUserNotifications([]));
    }
    // eslint-disable-next-line
  }, [openN]);
  useEffect(() => {
    const scrollElem =
      scrollRefNotif?.current?.children[0].childNodes[
        scrollRefNotif?.current?.children[0].childNodes.length - 1
      ];

    if (scrollElem && openN && isScrollNeeded) {
      scrollElem.scrollIntoView({ block: 'end', behavior: 'smooth' });
      setIsScrollNeeded(false);
      // eslint-disable-next-line
    }
    // eslint-disable-next-line
  }, [userNotifications, openN]);

  const onMessageReceived = (message) => {
    if (message === 'New notification') {
      apiNotification
        .getAll({ page: 0, size: 1 })
        .then((res) => {
          dispatch(setUserNotifications([...res?.result, ...userNotifications]));
          setNotifMaxCount(res?.total);
          dispatch(setSocketInfoMsg(null));
        })
        .catch((error) => console.error(error));
    }
  };

  useEffect(() => {
    if (socketInfoMsg && openN) {
      onMessageReceived(socketInfoMsg);
    }
    // eslint-disable-next-line
  }, [socketInfoMsg]);
  return (
    <RootStyle>
      <>{isOpenAuthModal && <AuthModal isOpenModal={isOpenAuthModal} />}</>

      <ToolbarStyle>
        <div
          className="header-logo"
          onClick={() => {
            navigate(`/`);
          }}
        />

        <Box className={`header-menu`}>
          <SearchBar
            display={{
              xs: 'none',
              sm: props?.userData?.id ? 'none' : 'block',
              md: props?.userData?.id ? 'none' : 'block',
              lg: 'block',
              xl: 'block'
            }}
          />
          <Box
            sx={{
              display: {
                xs: props?.userData?.id ? 'none' : 'block',
                sm: props?.userData?.id ? 'block' : 'none',
                md: props?.userData?.id ? 'none' : 'none'
              },
              flexDirection: 'column',
              alignItems: 'center',
              border: 'none',
              backgroundColor: 'white',
              borderRadius: '50px',
              padding: '5px 10px 10px 10px',
              cursor: 'pointer',
              height: '40px'
            }}
            onClick={() =>
              !window.location.href.includes('search') &&
              navigate(
                `/${props.language}/search/services?question=&ftsb=creationTimeForService&sd=DESC`
              )
            }
          >
            <Tooltip title="Пошук">
              <SearchIcon style={{ color: '#60A5DF', fontSize: '28px', pt: 0 }} />
            </Tooltip>
          </Box>
          {/* {!props?.userData?.id && (
            <button
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                border: 'none',
                backgroundColor: 'transparent',
                padding: '5px',
                cursor: 'pointer'
              }}
              onClick={handleClick}
            >
              <LanguageIcon style={{ color: '#60A5DF' }} />
              <Typography component="span" variant="body2" sx={{ '&:hover': { color: '#60A5DF' } }}>
                {' '}
                {translate('bonfair_language')}
              </Typography>
            </button>
          )} */}

          {props?.userData?.id && (
            <>
              <Box
                sx={{
                  display: {
                    xs: 'none',
                    sm: props?.userData?.id ? 'flex' : 'none',
                    md: props?.userData?.id ? 'flex' : 'none'
                  },
                  flexDirection: 'column',
                  alignItems: 'center',
                  border: 'none',
                  backgroundColor: 'transparent',
                  padding: '5px',
                  cursor: 'pointer'
                  // marginLeft: '15px'
                }}
                onClick={() =>
                  !window.location.href.includes('ribbon') && navigate(`/${props.language}/ribbon`)
                }
              >
                <Tooltip title={translate('bonfair_tape')}>
                  <BookOutlinedIcon style={{ color: '#60A5DF' }} />
                </Tooltip>
              </Box>
              <Box
                sx={{
                  display: {
                    xs: 'none',
                    sm: props?.userData?.id ? 'flex' : 'none',
                    md: props?.userData?.id ? 'flex' : 'none'
                  },
                  flexDirection: 'column',
                  alignItems: 'center',
                  border: 'none',
                  backgroundColor: 'transparent',
                  padding: '5px',
                  cursor: 'pointer',
                  marginLeft: '15px'
                }}
                onClick={() =>
                  !window.location.href.includes('messages') &&
                  navigate(`/${props.language}/messages`)
                }
              >
                <Tooltip title={translate('bonfair_correspondence')}>
                  <Badge color="error" variant={isNewMessage ? 'dot' : 'none'}>
                    <ChatBubbleOutlineIcon style={{ color: '#60A5DF' }} />
                  </Badge>
                </Tooltip>
              </Box>
              <Box
                sx={{
                  display: {
                    xs: props?.userData?.id ? 'flex' : 'none',
                    sm: props?.userData?.id ? 'flex' : 'none',
                    md: props?.userData?.id ? 'flex' : 'none'
                  },
                  flexDirection: 'column',
                  alignItems: 'center',
                  border: 'none',
                  backgroundColor: 'transparent',
                  padding: '5px',
                  cursor: 'pointer',
                  marginLeft: '15px',
                  marginRight: '15px'
                }}
                onClick={handleClickN}
              >
                <Tooltip title={translate('bonfair_notification')}>
                  <Badge color="error" variant={isNewNotification ? 'dot' : 'none'}>
                    <NotificationsNoneIcon style={{ color: '#60A5DF' }} />
                  </Badge>
                </Tooltip>
              </Box>
              <Box
                sx={{
                  display: {
                    xs: 'none',
                    sm: props?.userData?.id ? 'flex' : 'none',
                    md: props?.userData?.id ? 'flex' : 'none'
                  },
                  flexDirection: 'column',
                  alignItems: 'center',
                  border: 'none',
                  backgroundColor: 'transparent',
                  padding: '5px',
                  cursor: 'pointer',
                  marginRight: '15px'
                }}
                onClick={() =>
                  !window.location.href.includes('scheduler') &&
                  navigate(`/${props.language}/scheduler?tab=2`)
                }
              >
                <Tooltip title="Замовлення">
                  <DateRangeIcon style={{ color: '#60A5DF' }} />
                </Tooltip>
              </Box>
            </>
          )}

          {!props?.userData?.id ? (
            <StyledButton
              className="auth-btn-navbar"
              disableRipple
              onClick={() => dispatch(setIsOpenAuthModal(!props.isOpenAuthModal))}
            >
              {translate('bonfair_account_enter')}
            </StyledButton>
          ) : (
            <Tooltip title="Мій профіль">
              <button
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  border: 'none',
                  backgroundColor: 'transparent',
                  padding: '5px',
                  cursor: 'pointer'
                }}
                onClick={handleClick}
                // onClick={() => navigate(`/${props.language}/user-page/${props.userData.id}`)}
              >
                <ExpandMoreIcon
                  sx={{
                    mr: 0.5,
                    pl: 2,
                    borderLeft: '3px solid #F5F4F4!important',
                    fontSize: '40px',
                    cursor: 'pointer'
                  }}
                />
                <Typography sx={{ fontSize: '16px', mr: 2 }}>Профіль</Typography>
                <Avatar
                  src={props?.userData?.photoUrl ? `${props?.userData?.photoUrl}` : DefaultAvatar}
                  sx={{
                    width: 60,
                    height: 60,
                    border: '1px solid #60A5DF'
                  }}
                />
                {/* <Typography component="span" variant="body2" sx={{ '&:hover': { color: '#60A5DF' } }}>
                {translate('bonfair_account')}
              </Typography> */}
              </button>
            </Tooltip>
          )}
        </Box>
        <Menu
          anchorEl={anchorElN}
          id="notification-menu"
          open={openN}
          onClose={handleCloseN}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'hidden',
              boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
              borderRadius: '5px',
              border: 'none',
              paddingTop: '10px',
              paddingLeft: '10px',
              paddingRight: '10px',
              paddingBottom: notifMaxCount > userNotifications.length ? '0px' : '20px',
              // width: 'fit-content',
              width: '480px',
              mt: 1

              // '&:before': {
              //   content: '""',
              //   display: 'block',
              //   position: 'absolute',
              //   top: 0,
              //   right: 43,
              //   width: 10,
              //   height: 10,
              //   borderTop: '1px solid black',
              //   borderLeft: '1px solid black',
              //   bgcolor: 'background.paper',
              //   transform: 'translateY(-50%) rotate(45deg)',
              //   zIndex: 0
              // }
            }
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '10px',
                justifyContent: 'space-between'
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  fontFamily: 'FixelText-Medium',
                  fontSize: '16px',
                  textAlign: 'left',
                  fontWeight: '500',
                  position: 'relative'
                }}
              >
                Сповіщення
              </Typography>

              {userNotifications && userNotifications.length !== 0 ? (
                <Tooltip title="Видалити все" placement="top">
                  <DeleteOutlinedIcon
                    onClick={() => handleClickNDelete()}
                    sx={{ color: '#60A5DF', mb: 0.8, cursor: 'pointer' }}
                  />
                </Tooltip>
              ) : null}
            </Grid>
            {!isLoading ? (
              <>
                <Grid
                  ref={scrollRefNotif}
                  item
                  xs={12}
                  className="scrollableDiv"
                  sx={{
                    '&::-webkit-scrollbar': { display: 'none' },
                    maxHeight: '350px',
                    overflow: 'scroll'
                  }}
                >
                  {userNotifications && userNotifications.length !== 0 ? (
                    <Stack
                      sx={{ p: { xs: '8px 0px', sm: '10px 0px' }, gap: { xs: '8px', sm: '10px' } }}
                    >
                      {userNotifications.map((el, index) => (
                        <React.Fragment key={`notificationCard-${index}`}>
                          <Notification
                            index={index}
                            el={el}
                            deleteFunc={handleClickNDelete}
                            closeFunc={handleCloseN}
                          />
                        </React.Fragment>
                      ))}
                    </Stack>
                  ) : (
                    <Typography
                      sx={{
                        fontSize: '16px',
                        marginBottom: '5px !important',
                        textAlign: 'left',
                        position: 'relative'
                      }}
                    >
                      Немає нових сповіщень
                    </Typography>
                  )}
                </Grid>
                {notifMaxCount > notifPage + 1 && userNotifications.length !== 0 && (
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                    {!isLoadingMore ? (
                      <KeyboardArrowDownOutlinedIcon
                        onClick={() => handleLoadMoreNotif()}
                        sx={{ color: '#60a5df', fontSize: '40px', cursor: 'pointer' }}
                      />
                    ) : (
                      <div style={{ marginTop: '10px' }}>
                        <Spinner type="small" />
                      </div>
                    )}
                  </Grid>
                )}
              </>
            ) : (
              <Spinner type="small" />
            )}
          </Grid>
        </Menu>
        <Menu
          anchorEl={anchorEl}
          id="language-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'hidden',
              boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
              borderRadius: '5px',
              border: 'none',
              paddingTop: '10px',
              paddingLeft: '20px',
              paddingRight: '20px',
              paddingBottom: '10px',
              width: '300px',

              mt: 1,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              }
              // '&:before': {
              //   content: '""',
              //   display: 'block',
              //   position: 'absolute',
              //   top: 0,
              //   right: 43,
              //   width: 10,
              //   height: 10,
              //   borderTop: '1px solid black',
              //   borderLeft: '1px solid black',
              //   bgcolor: 'background.paper',
              //   transform: 'translateY(-50%) rotate(45deg)',
              //   zIndex: 0
              // }
            }
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          {/*<div*/}
          {/*  style={{*/}
          {/*    display: 'flex',*/}
          {/*    alignItems: 'center',*/}
          {/*    marginBottom: '20px',*/}
          {/*    marginLeft: '5px'*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <Avatar*/}
          {/*    src={props?.userData?.photoUrl ? `${props?.userData?.photoUrl}` : DefaultAvatar}*/}
          {/*    style={{*/}
          {/*      width: '50px',*/}
          {/*      height: '50px',*/}
          {/*      border: '1px solid #60A5DF'*/}
          {/*    }}*/}
          {/*  />*/}
          {/*  <Typography*/}
          {/*    component="p"*/}
          {/*    fontSize={16}*/}
          {/*    lineHeight="18px"*/}
          {/*    fontWeight={400}*/}
          {/*    sx={{ wordBreak: 'break-all', maxWidth: '90%' }}*/}
          {/*  >*/}
          {/*    {`@${props?.userData?.nickname}`}*/}
          {/*  </Typography>*/}
          {/*</div>*/}

          <MenuItem
            // selected={props.language === 'ua'}
            onClick={() => {
              if (!window.location.href.includes('user-page')) {
                navigate(`/${props.language}/user-page/${props.userData.id}?type=posts`);
              } else if (
                window.location.href.includes('user-page') &&
                params?.id !== props?.userData?.id
              ) {
                navigate(`/${props.language}/user-page/${props.userData.id}?type=posts`);
              }
            }}
            sx={{ padding: 0, pb: { xs: 0, sm: '10px' } }}
          >
            <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
              Профіль
            </Typography>
          </MenuItem>
          {props?.userData?.role === 'PREMIUM_USER' ||
          props?.userData?.role === 'USER' ||
          props?.userData?.role === 'FREEZE_PREMIUM' ? (
            <MenuItem
              // selected={props.language === 'ua'}
              onClick={() => !window.location.href.includes('tariffs') && navigate(`/ua/tariffs`)}
              sx={{ padding: 0, pb: { xs: 0, sm: '10px' } }}
            >
              <Typography
                component="p"
                variant="body1"
                fontSize={16}
                lineHeight="18px"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#60A5DF'
                }}
              >
                Преміум
                <StarIcon sx={{ color: '#60A5DF', ml: 1, fontSize: '18px' }} />
              </Typography>
            </MenuItem>
          ) : null}

          <MenuItem
            // selected={props.language === 'ua'}
            onClick={() =>
              !window.location.href.includes('saved') && navigate(`/ua/saved?type=posts`)
            }
            sx={{ padding: 0, pb: { xs: 0, sm: '10px' } }}
          >
            <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
              Збережені
            </Typography>
          </MenuItem>
          <MenuItem
            // selected={props.language === 'ua'}
            onClick={() => !window.location.href.includes('ribbon') && navigate(`/ua/ribbon`)}
            sx={{ padding: 0, display: { xs: 'flex', sm: 'none' }, pb: { xs: 0, sm: '10px' } }}
          >
            <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
              Стрічка
            </Typography>
          </MenuItem>
          <MenuItem
            // selected={props.language === 'ua'}
            onClick={() =>
              !window.location.href.includes('messages') && navigate(`/${props.language}/messages`)
            }
            sx={{ padding: 0, display: { xs: 'flex', sm: 'none' }, pb: { xs: 0, sm: '10px' } }}
          >
            <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
              Чати
            </Typography>
          </MenuItem>
          <MenuItem
            // selected={props.language === 'ua'}
            onClick={() =>
              !window.location.href.includes('search') &&
              navigate(
                `/${props.language}/search/services?question=&ftsb=creationTimeForService&sd=DESC`
              )
            }
            sx={{ padding: 0, display: { xs: 'flex', sm: 'none' }, pb: { xs: 0, sm: '10px' } }}
          >
            <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
              Пошук
            </Typography>
          </MenuItem>
          <MenuItem
            // selected={props.language === 'ua'}
            onClick={() =>
              !window.location.href.includes('scheduler') &&
              navigate(`/${props.language}/scheduler?tab=2`)
            }
            sx={{ padding: 0, display: { xs: 'flex', sm: 'none' }, pb: { xs: 0, sm: '10px' } }}
          >
            <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
              Замовлення
            </Typography>
          </MenuItem>

          <MenuItem
            // selected={props.language === 'ua'}
            onClick={() =>
              !window.location.href.includes('account-settings') && navigate(`/ua/account-settings`)
            }
            sx={{ padding: 0, pb: { xs: 0, sm: '10px' } }}
          >
            <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
              Налаштування
            </Typography>
          </MenuItem>
          <MenuItem
            sx={{ padding: 0, pb: { xs: 0, sm: '10px' }, borderBottom: '2px solid #F0F0F0' }}
            // selected={props.language === 'ua'}
            onClick={() =>
              !window.location.href.includes('support') && navigate(`/${props.language}/support`)
            }
          >
            <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
              Підтримка
            </Typography>
          </MenuItem>
          <MenuItem
            sx={{ padding: 0, pt: 1 }}
            // selected={props.language === 'ua'}
            onClick={() => {
              localStorage.removeItem('accessToken');
              localStorage.removeItem('refreshToken');
              localStorage.removeItem('feedbackModal');
              dispatch(setUserData({}));
              dispatch(setUserSubscribers([]));
              dispatch(setUserSubscriptions([]));
              dispatch(resetState());
              navigate(`/${props.language}`);
            }}
          >
            <Typography
              component="p"
              fontSize={16}
              lineHeight="18px"
              fontWeight={400}
              style={{ marginBottom: '10px', color: '#F64D36' }}
            >
              Вийти
            </Typography>
          </MenuItem>
        </Menu>
      </ToolbarStyle>
    </RootStyle>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    isOpenSearchBar: state.global.isOpenSearchBar,
    isOpenAuthModal: state.global.isOpenAuthModal
  };
};
export default connect(mapStateToProps, {
  getUserDataThunk: base.getUserDataThunk
})(Navbar);
